import Button from 'components/Button';
import Error from 'components/form/Error';
import { MenteeStatusValues } from 'enums/MenteeStatus';
import { FC, useContext, useState } from 'react';
import styled from 'styled-components';
import { mutate } from 'swr';
import privateAPI from 'utils/privateAxiosInstance';
import { ButtonsContainer } from '.';
import { MenteeEditContext } from '../..';

const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 1rem;
  }
  margin-bottom: 1rem;
`;

const Finished: FC = () => {
  const { mentee } = useContext(MenteeEditContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean>(false);

  const handleSetElligible = () => {
    setLoading(true);
    setError(false);
    privateAPI
      .patch(`/user/status/${mentee?.id}`, {
        menteeStatus: 'ELIGIBLE' as MenteeStatusValues,
      })
      .then(() => {
        mutate(`/user/${mentee!.id}`);
        mutate(`/mentorship/mentee/${mentee!.id}`);
        mutate(`/mentorship/mentee/${mentee!.id}/ongoing`);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  };
  return (
    <div>
      <ActionContainer>
        <p>Le mentorat a été terminé.</p>
        <ButtonsContainer>
          <Button
            color="primary"
            onClick={handleSetElligible}
            loading={loading}
          >
            Créer un nouveau mentorat
          </Button>
        </ButtonsContainer>
        {error && <Error>Une erreur est survenue.</Error>}
      </ActionContainer>
    </div>
  );
};

export default Finished;
